import { useCallback, useEffect } from 'react';

const useBrowserConfirmationBeforeTabClose = ({
  message,
  active,
}: {
  message: string;
  active: boolean;
}) => {
  const handleBeforeUnload = useCallback(
    (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = message;
    },
    [message],
  );

  useEffect(() => {
    if (active) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [handleBeforeUnload, active]);

  return;
};

export default useBrowserConfirmationBeforeTabClose;
